// Renders the agent's self-reported progress bar (the `set_progress` tool) as
// a horizontal row of phase ticks — done / current / upcoming — with a native
// `title` tooltip per tick showing that phase's name + description. Shared by
// the persistent-agents list page and the thread detail page (SidebarStatusBar
// + the State Signals tab). An agent has at most one bar.
import type { PersistentAgentProgressBar } from '@cortex/types';

export function ProgressBar({ bar }: { bar: PersistentAgentProgressBar }) {
  const currentIdx = bar.phases.findIndex((p) => p.id === bar.currentPhaseId);
  const currentPhase = currentIdx >= 0 ? bar.phases[currentIdx] : undefined;

  return (
    <div className="pa-progress">
      <div className="pa-progress__label">{bar.title}</div>
      <div className="pa-progress__ticks">
        {bar.phases.map((phase, i) => {
          const state =
            currentIdx < 0
              ? 'upcoming'
              : i < currentIdx
                ? 'done'
                : i === currentIdx
                  ? 'current'
                  : 'upcoming';
          return (
            <span
              key={phase.id}
              className={`pa-progress__tick pa-progress__tick--${state}`}
              title={phase.description ? `${phase.name} — ${phase.description}` : phase.name}
            />
          );
        })}
      </div>
      <div className="pa-progress__caption">
        {currentPhase
          ? `${currentPhase.name} (${currentIdx + 1}/${bar.phases.length})`
          : `${bar.phases.length} phase${bar.phases.length === 1 ? '' : 's'}`}
      </div>
    </div>
  );
}
